/**
 * Builds the audit line shown under a submission_round_outcome system comment.
 *
 * Format (per api-contract.md §4): comma-separated first names, NO "and",
 * NO Oxford comma. Falls back to the legacy string when there are no recipients.
 *
 *   []                          -> "Email sent to tenant"
 *   ["jessica"]                 -> "Email sent to jessica"
 *   ["jessica", "rick"]         -> "Email sent to jessica, rick"
 *   ["jessica", "rick", "al"]   -> "Email sent to jessica, rick, al"
 */
export const RECIPIENT_EMAIL_FALLBACK = "Email sent to tenant";

export function recipientEmailLine(recipients?: unknown): string {
  if (!Array.isArray(recipients)) return RECIPIENT_EMAIL_FALLBACK;

  const names = recipients
    .filter((n): n is string => typeof n === "string")
    .map((n) => n.trim())
    .filter((n) => n.length > 0);

  if (names.length === 0) return RECIPIENT_EMAIL_FALLBACK;

  return `Email sent to ${names.join(", ")}`;
}
